import { env } from "../lib/env"

export class HTMLAppVersionElement extends HTMLElement {
	#shadowRoot = this.attachShadow({ mode: "closed" })

	connectedCallback() {
		this.render()
	}

	render() {
		this.#shadowRoot.innerHTML = `${env.appName} v${env.appVersion} (${env.gitBranch} ${env.gitSha})`
	}
}

customElements.define("x-app-version", HTMLAppVersionElement)
